const AdBanner = () => {
  return (
    <div 
      data-testid="ad-banner"
      className="fixed bottom-0 left-0 right-0 h-[60px] bg-zinc-950 border-t border-zinc-800 flex items-center justify-center z-50"
      style={{
        backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(39, 39, 42, 0.5) 10px, rgba(39, 39, 42, 0.5) 20px)'
      }}
    >
      <p className="text-zinc-600 text-xs font-semibold tracking-widest uppercase">
        Ad Space Placeholder
      </p>
    </div>
  );
};

export default AdBanner;